import {
	createContext,
	default as React,
	type ReactNode,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { WorkOrdersReducer } from "../reducers/workOrdersReducer";

const WorkOrdersContext = createContext({
	state: WorkOrdersReducer.getInitialState(),
	actions: WorkOrdersReducer.actions,
});

export const useWorkOrdersContext = () => useContext(WorkOrdersContext);

export const WorkOrdersProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: WorkOrdersReducer.getInitialState(),
		reducers: WorkOrdersReducer.caseReducers,
	});

	return (
		<WorkOrdersContext.Provider value={{ state, actions }}>
			{children}
		</WorkOrdersContext.Provider>
	);
};
